import { useEffect, useState } from "react";
import { fetchUsers } from "../utils/api";
import "./admin.css";

export default function Dashboard() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUsers()
      .then((data) => setUsers(data))
      .finally(() => setLoading(false));
  }, []);

  const totalUsers = users.length;
  const activeUsers = users.filter(u => u.active).length;
  const inactiveUsers = totalUsers - activeUsers;

  return (
    <div className="dashboard">
      <h1 className="page-title">Dashboard</h1>
      <p className="page-subtitle">
        Overview of Oz Vehadar user activity
      </p>

      {loading ? (
        <p>Loading statistics…</p>
      ) : (
        <div className="stats-grid">
          <StatCard
            title="Total Users"
            value={totalUsers}
            color="blue"
          />
          <StatCard
            title="Active Users"
            value={activeUsers}
            color="green"
          />
          <StatCard
            title="Inactive Users"
            value={inactiveUsers}
            color="red"
          />
        </div>
      )}
    </div>
  );
}

function StatCard({ title, value, color }) {
  return (
    <div className={`stat-card ${color}`}>
      <div className="stat-title">{title}</div>
      <div className="stat-value">{value}</div>
    </div>
  );
}
